function ensure<T = any>(array?: T[]): T[] {
  return array ?? [];
}

function isEmpty<T = any>(array?: T[]): boolean {
  return !array || array.length === 0;
}

function isNotEmpty<T = any>(array?: T[]): boolean {
  return !isEmpty(array);
}

export const ArrayFuncs = {
  ensure,
  isEmpty,
  isNotEmpty,
};
